var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBooks = function SvgBooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.2 24.45 24.025 5.125a2 2 0 0 0-2.45-1.413L17.712 4.75l-.125.037A2 2 0 0 0 16 4h-4a2 2 0 0 0-1 .275A2 2 0 0 0 10 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h4c.352-.001.697-.096 1-.275.303.18.648.274 1 .275h4a2 2 0 0 0 2-2V13.55l3.475 12.962A2 2 0 0 0 23.413 28q.259-.004.512-.063l3.863-1.037a2 2 0 0 0 1.412-2.45m-7.113-18.8.788 2.887-3.863 1.038-.787-2.888zM16 6v15h-4V6zm-6 0v3H6V6zm6 20h-4v-3h4zm11.275-1.038L23.413 26l-.788-2.9 3.875-1.038z"
  })));
};
export default SvgBooks;